import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/UserProfile/UserContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/UserProfile/UserDetails.tsx");
